import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  container: {
    backgroundColor: theme.colors.card_background_primary_editable,
    paddingRight: theme.spacing(8),
    paddingLeft: theme.spacing(8),
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(3)
  },
  mortgagesContainer: {
    padding: theme.spacing(0, 6, 3, 8),
    paddingTop: 0,
    backgroundColor: theme.colors.card_background_primary_editable,
    borderTop: `1px solid ${theme.onCardDivider.white}`,
    width: '100%',
    // Reskin: the card body is already white; a square fill here clips the card's rounded corners.
    ...reskinStyles(theme, { backgroundColor: 'transparent' })
  },
  mortgageForm: {
    width: '100%',
    marginBottom: 0
  }
});

export default makeStyles(styles);
